import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPrintReason } from "src/models/Maintenance/PrintReason.models";

interface PrintReasonState {
  printReasons: IPrintReason[];
  printReasonToEdit: IPrintReason | null;
}

const initialState: PrintReasonState = {
  printReasons: [],
  printReasonToEdit: null,
};

const printReasonSlice = createSlice({
  name: "PrintReason",
  initialState,
  reducers: {
    setPrintReasonList: (state, action: PayloadAction<IPrintReason[]>) => {
      state.printReasons = action.payload;
    },
    concatListPrintReason: (
      state: PrintReasonState,
      action: PayloadAction<IPrintReason[]>
    ) => {
      state.printReasons = [...state.printReasons.concat(action.payload)];
    },
    setPrintReasonToEdit: (
      state,
      action: PayloadAction<IPrintReason | null>
    ) => {
      state.printReasonToEdit = action.payload;
    },
    addPrintReason: (state, action: PayloadAction<IPrintReason>) => {
      state.printReasons.push(action.payload);
    },
    updatePrintReason: (state, action: PayloadAction<IPrintReason>) => {
      let itemIndex = state.printReasons.findIndex(
        item => item.printReasonId === action.payload.printReasonId
      );
      if (itemIndex !== -1) state.printReasons[itemIndex] = action.payload;
    },
    deletePrintReason: (state, action: PayloadAction<number>) => {
      const newArray = state.printReasons.filter(
        item => item.printReasonId !== action.payload
      );
      state.printReasons = newArray;
    },
  },
});

export const {
  setPrintReasonList,
  concatListPrintReason,
  setPrintReasonToEdit,
  addPrintReason,
  updatePrintReason,
  deletePrintReason,
} = printReasonSlice.actions;

export default printReasonSlice.reducer;
